import React, { createContext } from 'react'
import { BusinessPaywallDrawer } from '../styledComponents'
import { useState } from 'react'
import PaywallComponent from './PaywallComponent'
import { Drawer, SwipeableDrawer } from '@mui/material'
import { paywallTempObject } from './paywallTempObject'
import { apiURL, commonHeadersWeb } from 'src/consumer/services'
import { getData } from 'src/consumer/services/profileService'
import { useEffect } from 'react'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'

export const BusinessPaywallContext = createContext()

export default function PaywallProvider({ children }) {
  const [showPaywall, setShowPaywall] = useState(false)
  const [paywallData, setPaywallData] = useState()
  const [testimonialData, setTestimonialData] = useState()

  function togglePaywall() {
    setShowPaywall((prev) => !prev)
  }

  function handleHidePaywall() {
    setShowPaywall(false)
  }
  function handleShowPaywall() {
    setShowPaywall(true)
  }

  async function getBusinessPlans() {
    const resp = await getData('/api/secure/bc/business-bundle-subscription-plans')
    if (resp.status === 200) {
      setPaywallData(resp.data)
    }
  }

  async function getTestimonials() {
    const resp = await getData('/api/secure/cc/testimonials')
    if (resp.status === 200) {
      setTestimonialData(resp.data)
    }
  }

  async function Setup() {
    await Promise.all([getBusinessPlans(), getTestimonials()])
  }

  useEffect(() => {
    const availableRoles = getAllRolesInBoolean()
    if (availableRoles.isBusinessCustomer) {
      Setup()
    }
  }, [])

  return (
    <>
      <SwipeableDrawer
        anchor="bottom"
        open={showPaywall}
        onClose={handleHidePaywall}
        onOpen={handleShowPaywall}
        transitionDuration={{ enter: 600, exit: 300 }}
        PaperProps={{
          sx: {
            minHeight: '100vh',
            height: '100vh',
          },
        }}
      >
        <PaywallComponent
          data={paywallData}
          testimonialData={testimonialData || paywallTempObject?.testimonials}
          togglePaywall={togglePaywall}
        />
      </SwipeableDrawer>
      <BusinessPaywallContext.Provider value={{ togglePaywall, paywallData, testimonialData }}>
        {children}
      </BusinessPaywallContext.Provider>
    </>
  )
}
